import { axiosInstance } from './httpClient';
import { API } from './env';
import MockApi from './mockApi';

export default class ReferralsApi {
    static getTopReferrers = (limit = 50) => {
        if (MockApi.IsActive) {
            return MockApi.GetTopReferrers();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/referrals/top-referrers?limit=${limit}`, config);
    };

    static searchUsersWithReferrals = (searchQuery, page = 1, limit = 20) => {
        if (MockApi.IsActive) {
            return MockApi.SearchUsersWithReferrals();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            searchQuery,
            page,
            limit
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/referrals/search`, JSON.stringify(body), config);
    };

    static getUserReferralDetails = (userId) => {
        if (MockApi.IsActive) {
            return MockApi.GetUserReferralDetails();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            userId
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/referrals/user-details`, JSON.stringify(body), config);
    };
}
